// Saying why a shift, a drawer or a day close was refused (2026-10-12). The server answers these with the plain codes
// (`conflict`, `unprocessable`) and a `detail` that names the shift, the cashier or the amount; that detail is the
// useful sentence, so it leads for those codes. Every other code reads from the catalogue like the rest of the console,
// and a code with no copy gets the action's own line.

import type { ErrorCode } from '@clavian/contracts';
import { useCallback } from 'react';

import { problemCode, problemDetail, problemStatus } from '../../api/problems';
import { useProblem } from '../../api/use-problem';

/** Codes that say little by themselves; the server's detail says what happened. */
const DETAIL_FIRST: ReadonlySet<string> = new Set<ErrorCode>(['conflict', 'unprocessable', 'validation_failed']);

export function useRefusalText(): (error: unknown, fallback: string) => string {
  const problem = useProblem();
  return useCallback(
    (error, fallback) => {
      const code = problemCode(error);
      const status = problemStatus(error);
      const detail = problemDetail(error);
      if (detail !== undefined && detail !== '' && code !== undefined && DETAIL_FIRST.has(code) && (status === undefined || status < 500)) return detail;
      return problem.text(error, { fallback });
    },
    [problem],
  );
}
